const xpaddingClassNameDesktop = "md:px-4";
export const xPaddingClassNameMobile = "px-2";
export const xPaddingClassName = `${xPaddingClassNameMobile} ${xpaddingClassNameDesktop}`;
